import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import styles from './home.module.scss';

const HomeNews = () => {
    return (<>

        <Container className={styles.mainContainer}>
            <div>
                <h2 className={'centerText' + ' ' + 'mb-4'}>News you can use</h2>
                <Row>
                    <Col md={12} lg={4} className={styles.newsColumn}>
                        <h4 className={'centerText' + ' ' + 'mb-4'}>Indicator Changes</h4>
                        <div className="mb-4"><p className={styles.newsDate}>February 17, 2021</p>
                            <p className='mb-1'><a href="https://www.qualityindicators.ahrq.gov/News/AHRQ_QI_v2020_PSI03_User_Note_02_2021.pdf">AHRQ publishes the explanation on PSI 03 (Pressure Ulcer Rate) measure logic used in v2020 QI software.</a></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>May 23, 2019</p>
                            <p className='mb-1'><a href="https://www.qualityindicators.ahrq.gov/News/Retirement%20Notice_v2019_Indicators.pdf">AHRQ announces the retirement of 21 indicators in v2019: PQI, IQI, PSI and PDI Indicators</a></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>December 15, 2017</p>
                            <p className='mb-1'><Link to="/software/">Release of AHRQ QI Beta software for v7.0.1 SAS QI and WinQI Software.</Link> </p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>September 22, 2017</p>
                            <p className='mb-1'><Link to="/software/">Release of AHRQ QI Beta software for v7.0 SAS QI and WinQI Software for organizations to apply the AHRQ Quality Indicators (QIs) to their own data to assist quality improvement efforts in acute care hospital settings.</Link> </p>
                        </div>
                    </Col>
                    <Col md={12} lg={4} className={styles.newsColumn}>
                        <h4 className={'centerText' + ' ' + 'mb-4'}>Software Releases</h4>
                        <div className="mb-4"><p className={styles.newsDate}>July 30, 2021</p>
                            <p className='mb-1'>
                                <Link to="/software/">Release of AHRQ QI SAS QI and WinQI v2021 software</Link><span class='new-label'> - New!</span></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>October 28, 2020</p>
                            <p className='mb-1'><Link to="/software/">Minor release of WinQI v2020.0.1 risk adjusted software</Link></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>July 31, 2020</p>
                            <p className='mb-1'><Link to="/software/">Release of AHRQ QI SAS QI and WinQI v2020 risk adjusted software</Link></p>
                        </div>

                        <div className="mb-4"><p className={styles.newsDate}>September 27, 2019</p>
                            <p className='mb-1'><Link to="/software/">Minor Release of AHRQ QI SAS QI (PSI Module) and WinQI v2019.0.1 ICD-10-CM/PCS risk adjusted software</Link></p>
                        </div>
                    </Col>
                    <Col md={12} lg={4} className={styles.newsColumn}>
                        <h4 className={'centerText' + ' ' + 'mb-4'}>Others</h4>
                        <div className="mb-4"><p className={styles.newsDate}>July 30, 2021</p>
                            <p className='mb-1'><a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/User_note_COVID.pdf">To learn the impact of COVID-19 on the AHRQ Quality Indicators <a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/COVID19_UserNote_July2021.pdf">click here.</a></a><span class='new-label'> - New!</span></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>May 18, 2021</p>
                            <p className='mb-1'><a href ="https://www.qualityindicators.ahrq.gov/Downloads/News/AHRQ_Rationale4notseekingNQFendorsement-May2021.pdf">AHRQ will no longer seek NQF re-endorsement for its portfolio of measures in the AHRQ Quality Indicators (QIs) program starting in fiscal year 2022.  </a></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>June 4, 2018</p>
                            <p className='mb-1'><a href="https://websurveyor2.airws.org/EFM/se/251137451D8BED86">Give us your input on the AHRQ Quality Indicators (QIs)!</a></p>
                        </div>
                        <div className="mb-4"><p className={styles.newsDate}>March 2, 2018</p>
                            <p className='mb-1'><Link to="/news/">Opportunity for Public Comment on Scientific Acceptability of AHRQ QIs for Quality Improvement efforts.</Link></p>
                        </div>
                    </Col>
                </Row>
                <Link className="btn btn-primary mt-3 centerText center" to="/news/">See All News</Link>
            </div>
        </Container>
    </>)
}

export default HomeNews;